module.exports = new __parcel__URL__("welcome-to-project-pages.873c33f5.png").toString();